// UxGridFrame > UxGridFrame
import React, { ComponentType } from 'react'
import className from 'classnames'
import { UxGridFrameProps as Props, UxGridFrameState as State } from './index'
import styles from './UxGridFrame.module.css'
import { defaultProps, UxGridFrameScrollPosition } from './IUxGridFrame'

export function withScroll<P extends object>(WrappedComponent: ComponentType<P>) {
	return class UxGridFrame extends React.PureComponent<P & Props, State> {
		static readonly defaultProps = defaultProps

		colWidth: number = 300
		scrollRef: React.RefObject<HTMLDivElement> = React.createRef()
		state = {
			shouldScroll: false,
			scrollHeight: 0,
			scrollWidth: 0,
			scrollTop: 0,
			scrollLeft: 0,
			offsetHeight: 0,
			offsetWidth: 0
		}

		componentDidMount() {
			const { startIx } = this.props
			const { current } = this.scrollRef

			if (current) {
				current.focus()
				current.scrollTop = startIx * 15 * 2 + startIx

				this.setState({
					scrollTop: startIx * 15 * 2 + startIx,
					scrollLeft: 0,
					scrollHeight: current.scrollHeight,
					scrollWidth: current.scrollWidth,
					offsetHeight: current.offsetHeight,
					offsetWidth: current.offsetWidth
				})
			}
		}

		_updateScrollPosition = (props: UxGridFrameScrollPosition) => {
			const { scrollTop, scrollLeft } = props
			const { current } = this.scrollRef
			const stateUpdate: Partial<State> = {}

			if (current) {
				current.focus()

				if (scrollTop && scrollTop !== this.state.scrollTop) {
					current.scrollTop = scrollTop // TODO improve the calculation / implementation of this scrollTop change
					stateUpdate.scrollTop = scrollTop
				}

				if (scrollLeft && scrollLeft !== this.state.scrollLeft) {
					current.scrollLeft = scrollLeft // TODO improve the calculation / implementation of this scrollTop change
					stateUpdate.scrollLeft = scrollLeft
				}
			}

			if (Object.keys(stateUpdate).length > 0) this.setState(stateUpdate as State)
		}

		// private _initScroll = () => {
		// 	// const { shouldScroll, top, left } = this.state
		// 	// const { current } = this.scrollRef
		// 	// if (current) {
		// 	// 	if (
		// 	// 		(current.scrollTop !== top || current.scrollLeft !== left) &&
		// 	// 		shouldScroll
		// 	// 	) {
		// 	// 		console.log('SCROLL TO', top, left)
		// 	// 		current.scrollTo({ top, left, behavior: 'smooth' })
		// 	// 		this.setState({ shouldScroll: false })
		// 	// 	}
		// 	// current.scrollTop = top
		// 	// current.scrollLeft = left
		// 	// }
		// }

		_handleScroll = () => {
			const { current } = this.scrollRef

			if (current) {
				current.focus()

				this.setState({
					scrollTop: current.scrollTop,
					scrollLeft: 0,
					scrollHeight: current.scrollHeight,
					scrollWidth: current.scrollWidth,
					offsetHeight: current.offsetHeight,
					offsetWidth: current.offsetWidth
				})
			}

			// event.preventDefault()
			// event.stopPropagation()
			// if (this.state.shouldScroll) return false
			// const stateUpdate: Partial<State> = {}
			// const { currentTarget, target } = event
			// const { top, left } = this.state
			// const { scrollTop, scrollLeft } = currentTarget
			// if (scrollTop !== top) stateUpdate.top = scrollTop
			// if (scrollLeft >= 0) {
			// 	const absDiff = Math.abs(scrollLeft - left)
			// 	if (absDiff > 10 && absDiff / currentTarget.offsetWidth > 0.1) {
			// 		// currentTarget.scrollLeft = left
			// 		if (scrollLeft < left) {
			// 			const value = this.calcScrollLeftNegative()
			// 			stateUpdate.left = left - value
			// 		}
			// 		if (scrollLeft > left) {
			// 			const value = this.calcScrollLeftPositive()
			// 			stateUpdate.left = left + value
			// 		}
			// 		stateUpdate.shouldScroll = true
			// 	}
			// }
			// this.setState(stateUpdate as State)
		}

		// private _calcScrollLeftNegative = (): number => {
		// 	const { current } = this.scrollRef

		// 	if (!current) return 0

		// 	const { offsetWidth, scrollLeft } = current

		// 	if (this._isAtStart()) {
		// 		return scrollLeft
		// 	} else {
		// 		return Math.min(scrollLeft, Math.floor(offsetWidth / this.colWidth) * this.colWidth)
		// 	}
		// }

		// private _calcScrollLeftPositive = (): number => {
		// 	const { current } = this.scrollRef

		// 	if (!current) return 0

		// 	const { offsetWidth, scrollWidth, scrollLeft } = current

		// 	if (this._isAtEnd()) {
		// 		return 0
		// 	} else {
		// 		return Math.min(
		// 			scrollWidth - scrollLeft - offsetWidth,
		// 			Math.floor(offsetWidth / this.colWidth) * this.colWidth
		// 		)
		// 	}
		// }

		// private _isAtStart = (): boolean => {
		// 	const { current } = this.scrollRef
		// 	if (!current) return false

		// 	const { scrollLeft } = current

		// 	if (scrollLeft < this.colWidth) return true
		// 	else return false
		// }

		// private _isAtEnd = (): boolean => {
		// 	const { numCols } = this.props
		// 	const { current } = this.scrollRef
		// 	if (!current) return false

		// 	const { scrollLeft } = current
		// 	const trigger = this.colWidth * (numCols - 1)

		// 	if (scrollLeft >= trigger) return true
		// 	else return false
		// }

		// private _doesRefExist = (): boolean => {
		// 	return !!this.scrollRef.current
		// }

		render() {
			const { shouldScroll, ...rest } = this.state
			const { startIx, ...restProps } = this.props

			return (
				<div
					ref={this.scrollRef}
					className={className('ux-grid-frame', styles.root)}
					onScroll={this._handleScroll}
				>
					<WrappedComponent
						scrollRef={this.scrollRef}
						scrollTo={this._updateScrollPosition}
						{...restProps as P}
						{...rest}
					/>
				</div>
			)
		}
	}
}
